import { Reducer } from 'redux/utils/Form'

import actionTypes from './assessmentServicePlanNeedIdentificationActionTypes'
import stateClass from './AssessmentServicePlanNeedIdentificationInitialState'

export default Reducer({
    stateClass,
    actionTypes
})